export const IconColor = ['yellow'] as const;
export type IconPropColor = typeof IconColor[number];

export const IconView = [
  'empty',
  'plus',
  'eye',
  'bars',
  'close',
  'trash',
  'search',
  'bold',
  'underline',
  'list-order',
  'list',
  'quotes',
  'undo',
  'redo',
  'down',
  'top',
  'left',
  'right',
  'fill-color',
  'add-file',
  'cite',
  'italic',
  'check',
  'move',
  'T',
  'play',
  'question',
  'danger',
  'compose',
  'success',
  'danger',
  'info-circle',
  'info-square',
  'edit',
  'home',
  'edit-square',
  'document',
  'folder-add',
  'back',
  'ellipsis-v',
  'ellipsis-h',
  'folder',
  'paper-upload',
  'add-user',
] as const;
export type IconPropView = typeof IconView[number];
